import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";
import { fetchMockEntityList } from "../mock/entityListMock";

// ─────────────────────────────────────────────────────────────────────────────
// Set USE_MOCK = true  → always use mock data (no API call)
// Set USE_MOCK = false → try real API, fall back to mock on failure
// ─────────────────────────────────────────────────────────────────────────────
const USE_MOCK = true;

export const fetchEntityListAction = async (
  pageNumber = 1,
  pageSize = 10,
  filters = {},
) => {
  // ── MOCK PATH ──────────────────────────────────────────────────────────────
  if (USE_MOCK) {
    console.log("[EntityList] Using mock data");
    return fetchMockEntityList(pageNumber, pageSize, filters);
  }

  // ── REAL API PATH (commented sections preserved for when API is ready) ─────
  try {
    const { entityName, emailAddress, entityCategory, status } = filters;

    const params = {
      pageNumber,
      pageSize,
      ...(entityName && { EntityName: entityName }),
      ...(emailAddress && { EmailAddress: emailAddress }),
      ...(entityCategory && { EntityCategory: entityCategory }),
      ...(status && { Status: status }),
    };

    const response = await apiClient.get(ATP_API_URL.GET_ALL_DATA_SEARCH, {
      params,
    });

    if (response?.status === 200 && response.data) {
      const responseData = response.data?.data || [];

      // Handle case where pagination is just a number (totalRecords)
      let totalRecords;
      if (typeof response.data.pagination === "number") {
        totalRecords = response.data.pagination;
      } else {
        const serverPagination = response.data?.pagination || {};
        totalRecords =
          response.data?.totalRecords ||
          serverPagination?.totalRecords ||
          serverPagination?.totalItems ||
          responseData.length;
      }

      const calculatedTotalPages = Math.ceil(totalRecords / pageSize);

      const paginationData = {
        currentPage: pageNumber,
        totalPages: calculatedTotalPages,
        totalItems: totalRecords,
        pageSize: pageSize,
        hasNextPage: pageNumber < calculatedTotalPages,
        hasPreviousPage: pageNumber > 1,
      };

      return {
        success: true,
        data: responseData,
        pagination: paginationData,
        message: "Entity list fetched successfully",
      };
    }

    // API returned non-200 — fall back to mock
    console.warn("[EntityList] API returned non-200, falling back to mock");
    return fetchMockEntityList(pageNumber, pageSize, filters);
  } catch (error) {
    // API call failed — fall back to mock so the UI still works
    console.warn(
      "[EntityList] API error, falling back to mock:",
      error.message,
    );
    return fetchMockEntityList(pageNumber, pageSize, filters);
  }
};
